import React from "react";
import { Check, X } from "lucide-react";
import Logo from "./Logo";

const comparisonRows = [
  { feature: "Unlimited Projects", teamboard: "check", trello: "Limited (10)", asana: "Paid only", monday: "3 boards" },
  { feature: "Secure Credentials Vault", teamboard: "check", trello: "cross", asana: "cross", monday: "cross", highlight: true },
  { feature: "Real-Time WebSocket Updates", teamboard: "check", trello: "Delayed", asana: "check", monday: "check" },
  { feature: "@Mentions & Comments", teamboard: "check", trello: "check", asana: "check", monday: "check", highlight: true },
  { feature: "Project Categories", teamboard: "check", trello: "Workspaces", asana: "check", monday: "check" },
  { feature: "Role-Based Access Control", teamboard: "check", trello: "Premium", asana: "Premium", monday: "Pro plan", highlight: true },
  { feature: "Email Invitations", teamboard: "check", trello: "check", asana: "check", monday: "check" },
  { feature: "Activity History & Audit", teamboard: "check", trello: "Basic", asana: "Premium", monday: "Pro plan", highlight: true },
  { feature: "Simple, Transparent Pricing", teamboard: "check", trello: "Complex tiers", asana: "Complex tiers", monday: "Per seat pricing" },
];

const MarketingComparisonTable = ({ className = "" }) => {
  return (
    <section className={`curved-section shell-sky section-animate ${className}`}>
      <div className="max-w-[95rem] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="section-eyebrow reveal">Why PMS?</span>
          <h2 className="reveal stagger-1 mt-4 mb-6">
            The smarter alternative to <span className="text-navy">Trello & others</span>
          </h2>
          <p className="text-lead reveal stagger-2">
            See why thousands of teams are switching from Trello, Asana, and Monday.com to PMS.
          </p>
        </div>
        <div className="comparison-table-container reveal stagger-3">
          <table className="comparison-table">
            <thead>
              <tr>
                <th className="text-left">Feature</th>
                <th className="text-center">
                  <div className="flex items-center justify-center gap-2">
                    <Logo className="text-[#CBEFFF]" />
                    PMS
                  </div>
                </th>
                <th className="text-center">Trello</th>
                <th className="text-center">Asana</th>
                <th className="text-center">Monday.com</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row, idx) => (
                <tr
                  key={row.feature}
                  className={row.highlight ? "highlight" : ""}
                >
                  <td className="font-medium text-gray-900">{row.feature}</td>
                  {[row.teamboard, row.trello, row.asana, row.monday].map((value, colIdx) => (
                    <td key={`${row.feature}-${colIdx}`} className="text-center">
                      {value === "check" ? (
                        <span className="inline-flex items-center justify-center w-8 h-8 bg-green-100 rounded-full">
                          <Check className="w-5 h-5 text-green-600" />
                        </span>
                      ) : value === "cross" ? (
                        <span className="inline-flex items-center justify-center w-8 h-8 bg-red-100 rounded-full">
                          <X className="w-5 h-5 text-red-500" />
                        </span>
                      ) : (
                        <span className="text-gray-500 text-sm font-medium">{value}</span>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default MarketingComparisonTable;
